import { z } from 'zod';
import { PointSchema } from './geojson';

export const ResponseAssetTypeSchema = z.enum([
  'vehicle',
  'personnel',
  'equipment',
  'drone',
  'aircraft',
]);
export type ResponseAssetType = z.infer<typeof ResponseAssetTypeSchema>;

export const ResponseAssetStatusSchema = z.enum([
  'available',
  'dispatched',
  'out_of_service',
  'offline',
]);
export type ResponseAssetStatus = z.infer<typeof ResponseAssetStatusSchema>;

export const ResponseAssetSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  type: ResponseAssetTypeSchema,
  status: ResponseAssetStatusSchema,
  location: PointSchema.optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type ResponseAsset = z.infer<typeof ResponseAssetSchema>;
